import { IDictionaryStringTo, IIFrameMessage, IIFrameMessagingBroker, IPromiseMessage } from "./Types";


export class IFrameMessagingBroker implements IIFrameMessagingBroker {
    private promiseMessageCallbacks: ((message: IIFrameMessage) => void)[] = [];
    private promiseCallbackIndex = 0;

    private messageHandlers: IDictionaryStringTo<((message: any) => void)[]> = {};

    public constructor(private validateMessageEvent?: (message: MessageEvent) => boolean) {

    }
    public async sendMessageWithPromise<T>(toWindow: Window, message: IIFrameMessage, targetOrigin = "*"): Promise<T> {
        const promiseMessage = this.constructPromiseMessage(message);
        const promiseIndex = promiseMessage.metadata.promiseIndex;

        this.sendMessage(toWindow, promiseMessage, targetOrigin);

        return new Promise<T>((resolve, reject) => {
            this.promiseMessageCallbacks[promiseIndex] = (promiseResponseMessage: IPromiseMessage) => {
                if (promiseResponseMessage.error) {
                    reject(Promise.reject(Error(promiseResponseMessage.error)));
                } else {
                    resolve(promiseResponseMessage.message);
                }
            };
        });
    }

    public sendMessage(toWindow: Window, message: IIFrameMessage, targetOrigin = "*") {
        this.sendPostMessage(toWindow, message, targetOrigin);
    }

    public processReceivedMessage(messageEvent: MessageEvent) {
        if (!this.validateMessageEvent || this.validateMessageEvent(messageEvent)) {
            const frameMessage = <IIFrameMessage>(messageEvent.data);
            this.invokeMessageHandlers(frameMessage);
            if (frameMessage.resolvePromise) {
                this.invokePromiseResponse(<IPromiseMessage>frameMessage);
            }
        }
    }

    public registerMessageHandlers(messageType: string, messageHandler: (message: any) => void) {
        if (!this.messageHandlers[messageType]) {
            this.messageHandlers[messageType] = [];
        }
        this.messageHandlers[messageType].push(messageHandler);
    }

    private sendPostMessage(toWindow: Window, message: IIFrameMessage, targetOrigin = "*") {
        toWindow.postMessage(message, targetOrigin);
    }

    private invokeMessageHandlers(message: IIFrameMessage) {
        if (this.messageHandlers[message.messageType]) {
            this.messageHandlers[message.messageType].forEach((callback: any) => callback(message));
        }
    }

    private invokePromiseResponse(message: IPromiseMessage) {
        const promiseMessageIndex = message.metadata?.promiseIndex;
        if (typeof promiseMessageIndex === 'number') {
            const promiseCallback = this.promiseMessageCallbacks[promiseMessageIndex];
            if (promiseCallback) {
                promiseCallback(message);
            }
        }
    }

    private getNextPromiseCallbackIndex() {
        return this.promiseCallbackIndex++;
    }

    private constructPromiseMessage(message: IIFrameMessage): IPromiseMessage {
        const promiseMessage = <IPromiseMessage>message;
        promiseMessage.metadata = { promiseIndex: this.getNextPromiseCallbackIndex() };

        return promiseMessage;
    }
}

let broker: IIFrameMessagingBroker;

export const IFrameMessagingBrokerFactory = {
    getIFrameMessagingBroker: (): IIFrameMessagingBroker => {
        if (!broker) {
            broker = new IFrameMessagingBroker();
        }

        return broker;
    }
}
